import React, { useMemo } from 'react';

import jsonExport from 'jsonexport/dist';
import {
  ChipField,
  downloadCSV,
  List as RaList,
  NumberField,
  TextField,
  usePermissions,
} from 'react-admin';

import { red } from '@material-ui/core/colors';

import ResponsiveList from '../components/lists/ResponsiveList';
import { useListStyles } from '../components/lists/useStyles';
import DateField from '../stats/fields/DateField';
import Actions from './Actions';
import DeleteButton from './buttons/DeleteButton';
import StatusField from './fields/StatusField';
import UserPaymentField from './fields/UserPaymentField';
import Filters from './Filters';

const exporter = (posts, b, c) => {
	const postsForExport = posts.map((post) => {
		const amount = new Intl.NumberFormat("it-IT", {
			style: "currency",
			currency: "EUR",
		}).format(post.amount);
		const status = post.status === "deleted" ? "Revocato" : "Detratto";
		const created = new Date(post.created).toLocaleDateString("it-IT", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		});

		return {
			"Anno di riferimento": post.target_year,
			Utente: post.user.name,
			Rendiconto: post?.user_payment
				? `${post.user_payment.name} / ${post.user_payment.status.name}`
				: "",
			Importo: amount,
			Status: status,
			"Richiesto il": created,
		};
	});

	jsonExport(
		postsForExport,
		{
			headers: [
				"Anno di riferimento",
				"Utente",
				"Rendiconto",
				"Importo",
				"Status",
				"Richiesto il",
			], // order fields in the export
		},
		(err, csv) => {
			downloadCSV(csv, "Sostituto D'Imposta"); // download as 'posts.csv` file
		}
	);
};

const List = (props) => {
	const classes = useListStyles();
	const { permissions } = usePermissions();
	const isAdmin = useMemo(
		() => permissions && permissions("admin"),
		[permissions]
	);
	return (
		<RaList
			{...props}
			classes={classes}
			perPage={25}
			filters={<Filters isAdmin={isAdmin} />}
			filterDefaultValues={{ target_year: new Date().getFullYear() }}
			sort={{ field: "created", order: "desc" }}
			exporter={exporter}
			actions={<Actions isAdmin={isAdmin} />}
			bulkActionButtons={false}
		>
			<ResponsiveList
				rowStyle={(r, i) => ({
					backgroundColor: r.deleted && red[50],
				})}
				mobileBody={
					<React.Fragment>
						<ChipField source="target_year" />
						{isAdmin && (
							<TextField
								source="user.name"
								label="resources.user-profile-approvals.fields.user_id"
								style={{ fontWeight: "bold" }}
							/>
						)}
						<TextField
							source="user_payment.name"
							label="resources.user-wtrs.fields.user_payment_id"
							style={{ fontWeight: "bold" }}
						/>
						<NumberField
							source="amount"
							options={{ style: "currency", currency: "EUR" }}
						/>
						<StatusField source="status" />
						<DateField showTime source="created" color="textSecondary" />
					</React.Fragment>
				}
				mobileActions={
					<React.Fragment>
						<DeleteButton
							isAdmin={isAdmin}
							label="resources.user-wtrs.actions.delete"
						/>
					</React.Fragment>
				}
			>
				<ChipField source="target_year" />
				{isAdmin && (
					<TextField
						source="user.name"
						label="resources.user-wtrs.fields.user_id"
						style={{ fontWeight: "bold" }}
					/>
				)}
				<UserPaymentField />
				<NumberField
					source="amount"
					options={{ style: "currency", currency: "EUR" }}
				/>
				<StatusField source="status" />
				<DateField showTime source="created" />
				<DeleteButton
					isAdmin={isAdmin}
					label="resources.user-wtrs.actions.delete"
				/>
			</ResponsiveList>
		</RaList>
	);
};
export default List;
